module.exports = __webpack_public_path__ + "static/media/lux.e56bd508.jpg";